import { PitchListOwner } from 'lib_ts/enums/pitch-list.enums';
import {
  PitchType,
  ReferenceListType,
  TrainingStatus,
} from 'lib_ts/enums/pitches.enums';

export interface IToolbarFilters {
  key: number;
  name: string;
  training_status: TrainingStatus[];
  visibility: PitchListOwner | undefined;
  reference_type: ReferenceListType | undefined;
  pitch_type: PitchType[];
  created: string[];
  teams: string[];
}

export const DEFAULT_TOOLBAR_FILTERS: IToolbarFilters = {
  created: [],
  key: Date.now(),
  name: '',
  pitch_type: [],
  reference_type: undefined,
  teams: [],
  training_status: [],
  visibility: undefined,
};
